import React, {useMemo, useState} from "react";
import {List} from "@material-ui/core";
import Loading from "components/Loading";
import {connect} from "react-redux";
import PapersGeneratorService from "services/PapersGeneratorService";
import PaperLink from "./PaperLink";
import BoldTypography from "components/BoldTypography";
import PapersGeneratorRfxInvitedSupplierWithOfferPopup from "./customPopups/PapersGeneratorRfxInvitedSupplierWithOfferPopup";
import PapersGeneratorRfxRequestPosition from "./customPopups/PapersGeneratorRfxRequestPosition";
import PapersGeneratorRfxInvitedSupplierPosition from "./customPopups/PapersGeneratorRfxInvitedSupplierPosition";
import ChooseSwzGeneratorOptions from "./customPopups/swzGenerator/ChooseSwzGeneratorOptions";
import PapersGeneratOfferFilesVerification from "./customPopups/PapersGeneratOfferFilesVerification";
import PapersGeneratorMessageFilesVerification from "./customPopups/PapersGeneratorMessageFilesVerification";
import reduxStore from "redux/store";
import {setSalesNotification} from "redux/actions";
import Endpoints from "constants/Endpoints";
import Tr from "translations/Translations";
import PapersGeneratorGzmManagementResolution from "./customPopups/gzm/PapersGeneratorGzmManagementResolution";
import PapersGeneratorGzmLeadingDocument from "./customPopups/gzm/PapersGeneratorGzmLeadingDocument";
import PapersGeneratorGzmDraftGroupAgreement from "./customPopups/gzm/PapersGeneratorGzmDraftGroupAgreement";
import PapersGeneratorGzmDocumentToSign from "./customPopups/gzm/PapersGeneratorGzmDocumentToSign";
import PapersGeneratorXmpUzpPresidentPaperPopup from "./customPopups/xmpUzpPresidentPaper/PapersGeneratorXmpUzpPresidentPaperPopup";
import {shareSystemsActive} from "libs/shareSystems";
import useSnackbar from "hooks/useSnackbar";
import PrivilegeService from "services/PrivilegeService";
import ShareSelectPopup, {sharePopupData} from "components/popup/ShareSelectPopup";

const DEF_CUSTOM_POPUP = {type: null, paper: null, shareSystem: null};
const PAPERS_SHARE_SUPPORTED_CUSTOM_POPUPS = ["rfxInvitedSupplierWithOffer", "rfxInvitedSupplierPosition", "rfxRequestPosition", "swzParams"]
const REPORT_SHARE_SUPPORTED_CUSTOM_POPUPS = ["rfxMessageVerification", "operator_form_verification_popup"]

const PapersGeneratorList = (
    {
        id,
        editable = true,
        papersGeneratorList,
        demandHeader,
        demandPrivileges = {}
    }) => {

    const [customPopup, setCustomPopup] = useState(DEF_CUSTOM_POPUP);
    const [paperWorking, setPaperWorking] = useState(null);
    const [sharePopupPaper, setSharePopupPaper] = useState(null);
    const {enqueueSuccessSnackbar} = useSnackbar();

    const shareSystems = useMemo(() => shareSystemsActive(demandHeader), [demandHeader])

    const paperClick = (paper) => {
        if (paperWorking)
            return;

        if (!paper.available) {
            reduxStore.dispatch(setSalesNotification(paper.salesModule));
            return;
        }

        if (!paper.customPopup) {
            if (paper.dictionary === 'papersGenerator') {
                setPaperWorking(paper.paperId);
                PapersGeneratorService.downloadPaper(Endpoints.PAPERS_GENERATOR_PRINT(id, paper.paperId),
                    () => setPaperWorking(null), () => setPaperWorking(null))
            } else if (paper.dictionary === 'reportsGenerator') {
                setPaperWorking(paper.paperId);
                let url
                if (paper.paperId === 'demandPrintProcessHistory')
                    url = Endpoints.PAPERS_GENERATOR_DEMAND_PROCESS_HISTORY(id);
                else if (paper.paperId === 'demandApprovalPrintHistory')
                    url = Endpoints.PAPERS_GENERATOR_DEMAND_APPROVAL_HISTORY(id);
                else if (paper.paperId === "purchasingGroupTemplateFormsReport")
                    url = Endpoints.PURCHASING_GROUP_MEMBERS_PAPERS_GENERATOR_TEMPLATE_FORM_EXPORT(id);
                else
                    url = Endpoints.PAPERS_GENERATOR_DEMAND_REPORT(id, paper.paperId);

                PapersGeneratorService.downloadPaper(url,
                    () => setPaperWorking(null), () => setPaperWorking(null))
            }
        } else {
            setCustomPopup({paper: paper, type: paper.customPopup, share: false})
        }
    }

    const shareClick = (paper) => {
        setSharePopupPaper(sharePopupData(paper.name, paper));
    }

    const doShare = (paper, system) => {
        setSharePopupPaper(null);
        if (paperWorking)
            return;

        if (!paper.available) {
            reduxStore.dispatch(setSalesNotification(paper.salesModule));
            return;
        }
        if (!paper.customPopup) {
            if (paper.dictionary === 'papersGenerator') {
                setPaperWorking(paper.paperId);
                PapersGeneratorService.sharePaper(id, paper.paperId, system).then(resp => resp ? enqueueSuccessSnackbar(Tr("int_upload_success_x", {x: system}, true)) : null).finally(() => setPaperWorking(null))
            } else if (paper.dictionary === 'reportsGenerator') {

            }
        } else {
            setCustomPopup({paper: paper, type: paper.customPopup, shareSystem: system})
        }
    }

    const showShare = (paper) => {
        return demandPrivileges.INTEGRATIONS_UPLOAD &&
            shareSystems.length > 0 && (!paper.customPopup || PAPERS_SHARE_SUPPORTED_CUSTOM_POPUPS.includes(paper.customPopup));
    }

    const showShareReport = (paper) => {
        return demandPrivileges.INTEGRATIONS_UPLOAD &&
            shareSystems.length > 0 && (REPORT_SHARE_SUPPORTED_CUSTOM_POPUPS.includes(paper.customPopup));
    }


    if (!papersGeneratorList) return <Loading/>
    return (
        <>
            {
                papersGeneratorList.modules.length > 0 && <>
                    <BoldTypography>{Tr('papers_generator_modules')}</BoldTypography>
                    <List>
                        {
                            papersGeneratorList.modules.map(paper => (
                                <PaperLink key={paper.paperId} editable={editable} demandId={id} paper={paper} paperWorking={paperWorking}
                                           paperClick={paperClick} showShare={false} shareClick={shareClick}/>))
                        }

                    </List>
                </>
            }

            <BoldTypography>{Tr('papers_generator_papers')}</BoldTypography>
            <List dense>
                {
                    papersGeneratorList.papers.map(paper => (
                        <PaperLink key={paper.paperId} editable={editable} demandId={id} paper={paper} paperWorking={paperWorking} paperClick={paperClick}
                                   showShare={showShare(paper)} shareClick={shareClick}
                        />))
                }
            </List>

            {
                papersGeneratorList.reports.length > 0 && <>
                    <BoldTypography>{Tr('papers_generator_reports')}</BoldTypography>
                    <List dense>
                        {
                            papersGeneratorList.reports.map(paper => (
                                <PaperLink key={paper.paperId} editable={editable} demandId={id} paper={paper} paperWorking={paperWorking} paperClick={paperClick}
                                           showShare={showShareReport(paper)} shareClick={shareClick}/>))
                        }

                    </List>
                </>
            }

            {customPopup.type === 'rfxInvitedSupplierWithOffer' &&
                <PapersGeneratorRfxInvitedSupplierWithOfferPopup demandId={id} paper={customPopup.paper} onClose={() => setCustomPopup(DEF_CUSTOM_POPUP)}
                                                                 shareSystem={customPopup.shareSystem}/>}

            {customPopup.type === 'rfxRequestPosition' && <PapersGeneratorRfxRequestPosition demandId={id} paper={customPopup.paper} onClose={() =>
                setCustomPopup(DEF_CUSTOM_POPUP)} shareSystem={customPopup.shareSystem}/>}

            {customPopup.type === 'rfxInvitedSupplierPosition' &&
                <PapersGeneratorRfxInvitedSupplierPosition demandId={id} paper={customPopup.paper} onClose={() => setCustomPopup(DEF_CUSTOM_POPUP)}
                                                           shareSystem={customPopup.shareSystem}/>}

            {customPopup.type === 'swzParams' &&
                <ChooseSwzGeneratorOptions shareSystem={customPopup.shareSystem} id={id} onClose={() => setCustomPopup(DEF_CUSTOM_POPUP)}/>}

            {customPopup.type === 'operator_form_verification_popup' &&
                <PapersGeneratOfferFilesVerification shareSystem={customPopup.shareSystem}  demandId={id} paper={customPopup.paper} onClose={() => setCustomPopup(DEF_CUSTOM_POPUP)}/>}

            {customPopup.type === 'rfxMessageVerification' &&
                <PapersGeneratorMessageFilesVerification shareSystem={customPopup.shareSystem} demandId={id} paper={customPopup.paper} onClose={() => setCustomPopup(DEF_CUSTOM_POPUP)}/>}

            {customPopup.type === 'gzmManagementResolution' &&
                <PapersGeneratorGzmManagementResolution groupId={id} paper={customPopup.paper} onClose={() => setCustomPopup(DEF_CUSTOM_POPUP)}/>}

            {customPopup.type === 'gzmLeadingDocument' &&
                <PapersGeneratorGzmLeadingDocument groupId={id} paper={customPopup.paper} onClose={() => setCustomPopup(DEF_CUSTOM_POPUP)}/>}

            {customPopup.type === 'gzmDraftGroupAgreement' &&
                <PapersGeneratorGzmDraftGroupAgreement groupId={id} paper={customPopup.paper} onClose={() => setCustomPopup(DEF_CUSTOM_POPUP)}/>}

            {customPopup.type === 'gzmDocumentToSign' &&
                <PapersGeneratorGzmDocumentToSign groupId={id} paper={customPopup.paper} onClose={() => setCustomPopup(DEF_CUSTOM_POPUP)}/>}

            {customPopup.type === 'xml_uzp_president_popup' &&
                <PapersGeneratorXmpUzpPresidentPaperPopup demandId={id} onClose={() => setCustomPopup(DEF_CUSTOM_POPUP)}/>}

            {!!sharePopupPaper &&
                <ShareSelectPopup data={sharePopupPaper} onCancel={() => setSharePopupPaper(null)} onChoose={(paper, system) => doShare(paper, system)}/>}

        </>)
}

export default connect((state) => ({
    papersGeneratorList: state.resources[PapersGeneratorService.PAPERS_GENERATOR_LIST_RESOURCE_ID],
    demandHeader: state.resources.demandHeader,
    demandPrivileges: state.privileges[PrivilegeService.DEMAND_PRIVILEGE_STORE_KEY],
}), {})(PapersGeneratorList);
